<table mat-table [dataSource]="data">
  <ng-container matColumnDef="action">
    <td mat-cell *matCellDef="let element">
      @if (myMarketsService.myMarkets$ | async; as myMarkets) {
        @let marketExists = myMarkets.has(element?.marketId);
        @let marketAddedManually = myMarkets.get(element?.marketId)?.source === "manual";
        @if (marketExists && marketAddedManually) {
          <button (click)="removeFromMyMarkets(element?.marketId)">
            <mat-icon color="warn" [matTooltip]="'Remove from My Market' | translate">cancel</mat-icon>
          </button>
        }
        @if (!marketAddedManually) {
          <button [disabled]="marketExists" (click)="addToMyMarkets(element?.marketId)">
            <mat-icon [matTooltip]="'Add to My Market' | translate" [matTooltipDisabled]="marketExists">add_circle</mat-icon>
          </button>
        }
      }
    </td>
  </ng-container>
  <ng-container matColumnDef="marketStartTime">
    <td mat-cell *matCellDef="let element">
      {{ element?.marketStartTime | date: "HH:mm" }}
    </td>
  </ng-container>
  <ng-container matColumnDef="eventType">
    <td class="e-type-td" mat-cell *matCellDef="let element">
      {{ element?.eventType?.name }}
    </td>
  </ng-container>
  <ng-container matColumnDef="event">
    <td mat-cell *matCellDef="let element">
      <a
        class="e"
        [routerLink]="[
          '/app/main',
          {
            outlets: {
              navigation: ['event', element?.event?.id],
              content: ['event-markets', element?.event?.id],
            },
          },
        ]">
        <span class="text-link">
          {{ element?.event?.name }}
        </span>
      </a>
    </td>
  </ng-container>
  <ng-container matColumnDef="competition">
    <td mat-cell *matCellDef="let element">
      {{ element.competition?.name }}
    </td>
  </ng-container>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
